import type { TLandingContext } from '@/interfaces';

export type TTenantAdminHomeTarget = 'class' | 'admin';

export interface ITenantAdminHomeTargetInput {
  hasCurrentClass: boolean;
  isClassContext: boolean;
  preferredLandingContext: TLandingContext | null;
}

export const resolveTenantAdminHomeTarget = ({
  hasCurrentClass,
  isClassContext,
  preferredLandingContext,
}: ITenantAdminHomeTargetInput): TTenantAdminHomeTarget => {
  const shouldOpenClassContext = preferredLandingContext === 'class' || (!preferredLandingContext && isClassContext);

  if (hasCurrentClass && shouldOpenClassContext) return 'class';

  return 'admin';
};
